import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { HomepageSection } from '../utils/types';

export type SectionsState = {
  sections?: HomepageSection[];
};

const initialState: SectionsState = {
  sections: undefined
};

const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {
    setSections: (state, action: PayloadAction<HomepageSection[] | undefined>) => {
      state.sections = action.payload;
    }
  }
});

export const { setSections } = sectionsSlice.actions;
export default sectionsSlice.reducer;
